type OpenDialerCb = (to?: string) => void;
const listeners: OpenDialerCb[] = [];

export function openIvrDialer(to?: string): void {
  listeners.forEach(fn => fn(to));
}

export function subscribeIvrDialer(fn: OpenDialerCb): () => void {
  listeners.push(fn);
  return () => {
    const i = listeners.indexOf(fn);
    if (i >= 0) listeners.splice(i, 1);
  };
}
